<mat-card>
  <mat-card-header>
    <div class="full-width">
      <ng-content select="[collapsable-ui-header]"></ng-content>
    </div>
  </mat-card-header>
  <mat-card-content>
    <div [@expandCollapse]="{ value: expandedState, params: { height: collapsedHeight } }">
      <ng-content select="[collapsable-ui-content]"></ng-content>
    </div>
  </mat-card-content>
  <mat-card-footer>
    <div class="text-center">
      <button mat-button color="secondary" (click)="toggleExpand()">
        <mat-icon iconPositionStart [@arrowRotate]="expandedState">expand_more</mat-icon>
        {{ (isExpanded ? 'GENERAL.BUTTON.SHOW_LESS' : 'GENERAL.BUTTON.SHOW_MORE') | translate }}
      </button>
    </div>
  </mat-card-footer>
</mat-card>
